import React, { useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import { getDeliveryChannel } from "../../../../utils/constants";
import { DeliveryModal } from "./DeliveryModal";

// Canal + costo de envío de un delivery, como botón para corregirlos
// ("🛵 PedidosYa · Envío S/ 5.00"). Se usa en "Añadir pedido" y en la mesa.
export function DeliveryInfo(props) {
  const { title, channel, fee, onChange } = props;
  const [show, setShow] = useState(false);
  const channelData = getDeliveryChannel(channel);

  return (
    <>
      <Button basic size="small" onClick={() => setShow(true)} title="Cambiar canal o costo de envío">
        <Icon name="motorcycle" />
        {channelData ? channelData.text : "Canal y envío"}
        {fee != null && ` · Envío S/ ${Number(fee).toFixed(2)}`}
      </Button>
      <DeliveryModal
        show={show}
        title={title}
        initialChannel={channel}
        initialFee={fee}
        onCancel={() => setShow(false)}
        onConfirm={async (newChannel, newFee) => {
          await onChange(newChannel, newFee);
          setShow(false);
        }}
      />
    </>
  );
}
